
import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';
import { ResourceQuery } from '~src/httpClient/resources/ResourceQuery';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';
import { LongRunningAction } from '~src/permissions/services/LongRunningAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { BroadcastServerApiHelper } from '../serverApi/broadcastServerApiHelper';
import { CreateBroadcastViewRequest } from '../serverApi/requests/CreateBroadcastViewRequest';
import { DeleteBroadcastRequest, IDeleteBroadcastResult } from '../serverApi/requests/DeleteBroadcastRequest';
import { GetBroadcastViewsRequest } from '../serverApi/requests/GetBroadcastViewsRequest';
import { GetDetailOfABroadcastRequest, IGetDetailBroadcastResult } from '../serverApi/requests/GetDetailOfABroadcastRequest';


class BroadcastsResource {
    private getBroadcastViews = new WebClientListResourceFetcher(GetBroadcastViewsRequest,
        BroadcastServerApiHelper.broadcastItems);

    public getAllBroadcasts(): ResourceQuery<IContentInfo> {
        return new ResourceQuery<IContentInfo>(this.getBroadcastViews);
    }

    public getDetailOfABroadcast(viewLuid: string): Promise<IGetDetailBroadcastResult> {
        const request = new GetDetailOfABroadcastRequest({ viewLuid: viewLuid });
        return WebHttpClientWithErrorToastInstance.sendRequest(request);
    }

    public createBroadcast(viewId: string, showTabs: boolean, showWatermark: boolean, overwrite: boolean, acceptTermsOfUse: boolean): Promise<any> {
        const request = new CreateBroadcastViewRequest({ viewId: viewId, overwrite: overwrite, showTabs: showTabs, showWatermark: showWatermark, acceptTermsOfUse: acceptTermsOfUse});
        return WebHttpClientWithErrorToastInstance.sendRequest(request)
            .then(LongRunningAction.getActionIdFromActionResult)
            .then((actionId: string) =>
                LongRunningAction.trackAsyncJobProgressWithPromise(actionId));
    }

    public deleteBroadcast(viewLuid: string): Promise<IDeleteBroadcastResult> {
        return WebHttpClient.sendRequest(new DeleteBroadcastRequest({ viewLuid: viewLuid }));
    }
}

export const Broadcasts = new BroadcastsResource();
